/**
 * MSW on/off 상태 관리.
 * 우선순위: localStorage("msw-enabled") > NEXT_PUBLIC_MSW_ENABLED > false
 * localStorage 변경 후에는 reload 필요 (서비스워커 lifecycle 때문).
 */

const STORAGE_KEY = 'msw-enabled';

function getEnvEnabled(): boolean {
  return process.env.NEXT_PUBLIC_MSW_ENABLED === 'true';
}

/** 현재 세션에서 MSW가 켜져있는지 판정. SSR에선 env 기준. */
export function isMswEnabled(): boolean {
  if (typeof window === 'undefined') return getEnvEnabled();
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'true') return true;
  if (stored === 'false') return false;
  return getEnvEnabled();
}

/** 토글 후 reload. override 지정 시 해당 값으로 강제. */
export function setMswEnabled(next: boolean) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, String(next));
  window.location.reload();
}
